<ng-template #htmlContent>
  <img *ngIf="selectedImageUrl" [src]="selectedImageUrl" class="tooltip-img" />
</ng-template>

<div class="table-responsive-md gung-responsive" *ngIf="mappedData; else loading">
  <table class="table table-striped" *ngIf="mappedData && mappedData.length > 0">
    <thead class="thead-sticky">
      <tr>
        <th class="" translate>ITEM_NO</th>
        <th class="" translate>CROSS_REFERENCE_TO_OO</th>
        <th class="" translate>PRODUCER</th>
        <th translate></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData; index as i">
        <td [attr.data-label]="'ITEM_NO' | translate">
          {{ item.product.extra?._ottoFilterModel?.ottoProductId }}
        </td>
        <td [attr.data-label]="'CROSS_REFERENCE_TO_OO' | translate">
          {{ item.product.extra?._ottoFilterModel?.hifiReference }}
        </td>
        <td [attr.data-label]="'BRAND' | translate">
          {{ item.product.extra?._ottoFilterModel?.crossBrand }}
        </td>
        <td width="1%" [attr.data-label]="'PRICE' | translate">
          @if (!item.product.extra?._nonJeevesProduct) {
            <div
              [class.d-none]="!!item.product.extra?.ar?.konfigartnr"
              *ngIf="
                !(
                  item.product.extra.pim &&
                  item.product.extra.pim.pricerequest &&
                  item.product.extra.pim.pricerequest !== 'false'
                ) &&
                !(item.product.extra?.ar?.itemtypecd1 === 0 || item.product.extra?.ar?.itemtypecd1 === 7)
              "
            >
              <div *ngIf="!isAnonymous && item.price" class="text-center">
                <otto-olsen-price-list-display [price]="item.price" [product]="item.product"></otto-olsen-price-list-display>
              </div>
            </div>
          }
        </td>
        <td width="1%" [attr.data-label]="'' | translate">
          <div
            *ngIf="
              (!(
                item.product.extra.pim &&
                item.product.extra.pim.pricerequest &&
                item.product.extra.pim.pricerequest !== 'false'
              ) &&
              !(item.product.extra?.ar?.itemtypecd1 === 0 || item.product.extra?.ar?.itemtypecd1 === 7))
              && !item.product.extra?._nonJeevesProduct
              ; else priceRequest
            "
          >
            <otto-olsen-buy-btn
              name="buy-btn-package-size"
              class="height-30 ml-auto"
              style="width: 150px"
              [id]="item.product?.id"
              [minimumOrderQuantity]="item.product?.firstStepAmount || item.product?.packageSize"
              [stepAmount]="item.product?.packageSize"
              [decimals]="item.product?.extra.ar.antdec"
              [originalSize]="item.product?.originalSize"
              [unit]="item.product?.extra.ar?.enhetskod"
              [activeInB2B]="item.product?.extra?.pim?.activeInB2B"
              [product]="item.product"
              [availability]="item.availability"
            ></otto-olsen-buy-btn>
            <div class="text-center" *ngIf="!isAnonymous">
              <otto-olsen-availability
                [availability]="item.availability"
                [unit]="item.product.extra.ar?.enhetskod"
                [decimals]="item.product?.extra.ar.antdec"
                [productionDays]="
                  item.product?.extra.ar?.anskaffningssatt &&
                  item.product?.extra.ar?.anskaffningssatt * 1 === 12 &&
                  item.product?.extra.ar?.artgenomloppstid"
              ></otto-olsen-availability>
            </div>
          </div>
          <ng-template #priceRequest>
            <a
              href="mailto:{{ requestPriceEmail }}?subject=Forespørsel {{ item.product.id }}"
              target="_blank"
              class="request-price-email"
            >
              <button type="button" class="btn btn-block btn-sm btn-primary ml-auto" style="width: 150px" translate>
                CONTACT_US
              </button>
            </a>
          </ng-template>
        </td>
        <td width="1%" [attr.data-label]="'FAVOURITES' | translate">
          @if (!item.product.extra?._nonJeevesProduct) {
          <otto-olsen-favourite-product-icon-only
            class="favourite-element"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            [id]="item.product.id"
          ></otto-olsen-favourite-product-icon-only>
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #loading>
  <i class="fa fa-spinner fa-spin fa-7x"></i>
</ng-template>
